import { visionURL } from "../config/environment";
import Jsona from "jsona";
import JsonApiService from "../services/jsonapiService";
import visionCallService from "../services/visionCallService";

const dataFormatter = new Jsona();

const coursesApiService = async () =>
  new JsonApiService("courses", {
    baseUrl: `${visionURL}/admin_console/api/course_builder`,
    credentials: "include"
  });

const batchAddCoursesApiService = async () =>
  new JsonApiService("bulk_create_course_sections", {
    baseUrl: `${visionURL}/admin_console/api/course_builder`,
    credentials: "include"
  });

const contentApiService = async () =>
  new JsonApiService("items", {
    baseUrl: `${visionURL}/admin_console/api/content`,
    credentials: "include"
  });

export const useCourses = () => {
  return {
    getCourses: async ({
      page,
      pageSize,
      orderBy,
      orderDirection,
      filters
    }) => {
      const service = await coursesApiService();
      const response = await service
        .page({ number: page, size: pageSize })
        .orderBy(orderBy)
        .orderDirection(orderDirection)
        .where(filters)
        .include("packages")
        .all()
        .then(response => response.json());
      return {
        data: dataFormatter.deserialize(response),
        ...response.meta
      };
    },
    addCourses: async (destinationCourseId, sourceCourseIds) => {
      const service = await batchAddCoursesApiService();
      const requestBody = {
        relationshipNames: [
          "sourceTrainingObjects",
          "destinationTrainingObject"
        ]
      };
      requestBody.sourceTrainingObjects = sourceCourseIds.map(courseId => ({
        id: courseId,
        type: "trainingObject"
      }));
      requestBody.destinationTrainingObject = {
        id: destinationCourseId,
        type: "trainingObject"
      };
      const response = await service
        .create(
          visionCallService.serializeRequestBody(
            requestBody,
            "bulkCreateCourseSections"
          )
        )
        .then(response => response.json());
      const responseData = {
        data: dataFormatter.deserialize(response),
        ...response.meta
      };
      console.log(responseData);
      return responseData;
    }
  };
};

export const useItems = () => {
  return {
    deleteItem: async ({ itemId }) => {
      const service = await contentApiService();
      const response = await service.delete(itemId);
      return response;
    }
  };
};
